export interface ScheduledActor {
  id: string;
  stepDebt?: number;
  stepInterval?: number;
  nextStepAt?: number;
  stepOffset?: number;
}

/** Distant activity receives all elapsed simulation time, with stable phases
 * distributed over the fixed clock. Promotion drains the same outstanding debt
 * immediately. No movement time is discarded or invented by this schedule. */
export function actorStep(actor: ScheduledActor, dt: number, now: number, interval: number): number {
  const previousInterval = actor.stepInterval;
  actor.stepDebt = (actor.stepDebt ?? 0) + dt;
  actor.stepInterval = interval;
  if (interval > dt + 1e-6) {
    if (actor.stepOffset === undefined) {
      let hash = 2166136261;
      for (let i = 0; i < actor.id.length; i++) hash = Math.imul(hash ^ actor.id.charCodeAt(i), 16777619);
      actor.stepOffset = (hash >>> 0) / 4294967296;
    }
    if (actor.nextStepAt === undefined || previousInterval !== interval)
      actor.nextStepAt = now + actor.stepOffset * interval;
    if (now + 1e-6 < actor.nextStepAt) return 0;
    actor.nextStepAt += Math.max(1, Math.floor((now - actor.nextStepAt + 1e-6) / interval) + 1) * interval;
  } else actor.nextStepAt = undefined;
  const elapsed = actor.stepDebt;
  actor.stepDebt = 0;
  return elapsed;
}
